var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHochreinesZink90ProzentAnteil = function SvgHochreinesZink90ProzentAnteil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Hochreines_Zink_90_Prozent_Anteil_svg__Ebene_2",
    viewBox: "0 0 101.42 87.83"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Hochreines_Zink_90_Prozent_Anteil_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.35 87.83 0 43.91 25.35 0h50.71l25.36 43.91-25.36 43.92z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Hochreines_Zink_90_Prozent_Anteil_svg__cls-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Hochreines_Zink_90_Prozent_Anteil_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.48 2.74 23.77 41.17-23.77 41.18H26.93L3.16 43.91 26.93 2.74zM76.06 0H25.35L0 43.91l25.35 43.91h50.71l25.35-43.91z",
    className: "Hochreines_Zink_90_Prozent_Anteil_svg__cls-2",
    style: {
      clipPath: "url(#Hochreines_Zink_90_Prozent_Anteil_svg__clippath)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.85 58.49v-4.37l19.06-26.47H24.85v-4.69h25.93v4.37L31.72 53.8h19.44v4.69zM74.85 58.49V42.04c0-4.26-2.18-5.64-5.49-5.64-2.98 0-5.7 1.81-7.08 3.73V58.5h-4.79V32.78h4.79v3.62c1.7-2.08 5.11-4.26 9.11-4.26 5.43 0 8.25 2.88 8.25 8.31V58.5h-4.79Z",
    className: "Hochreines_Zink_90_Prozent_Anteil_svg__cls-2"
  }))));
};
export default SvgHochreinesZink90ProzentAnteil;